package tta.destinigo.talktoastro.feature_profile.chat_history.data

import tta.destinigo.talktoastro.feature_profile.chat_history.data.response.ChatConversationData

sealed class ChatConversationState {
    data object Loading : ChatConversationState()
    data class Success(val chatMessages: List<ChatConversationData?>) : ChatConversationState()
    data class Error(val message: String) : ChatConversationState()
}